<template>
  <b-form-group
    :label="label">
    <b-form-input
      :ref="`ref${name}`"
      type="time"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :state="verificaEstadoInput()"
      v-model="valor"
      @input="onStateInput($event, 'onInput')"
      @change="onStateInput($event, 'onChange')"
      @update="onStateInput($event, 'onUpdate')"
      @blur="$emit('blur')"
      autocomplete="off"
    />
    <b-form-invalid-feedback>
      {{ retornaMensagemDeErro() }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import moment from 'moment-timezone'
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input'
import bFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'

import InputBaseMixins from './mixins/InputBaseMixins'

moment.locale('pt-br')

export default {
  name: 'InputHora',
  mixins: [InputBaseMixins],
  props: {
    value: {
      required: true,
    },
  },
  components: {
    bFormGroup,
    bFormInput,
    bFormInvalidFeedback,
  },
  computed: {
    valor: {
      get() {
        if (this.value) {
          return moment.tz(this.value, 'America/Sao_Paulo').format('HH:mm')
        }
        return ''
      },
      set(val) {
        if (val) {
          const dataHora = moment.tz(`2019-01-01 ${val}`, 'America/Sao_Paulo').format()
          this.$emit('input', dataHora)
        }
      },
    },
  },
}

</script>
